import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=4b2bc961&scoped=true&"
import script from "./NotificationSetting.vue?vue&type=script&lang=ts&"
export * from "./NotificationSetting.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=4b2bc961&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bc961",
  null
  
)

export default component.exports